import { KEY_STORAGE_ITEM, TIMESTAMP_STORAGE_ITEM } from "./definitions"
import { getMaintenanceModeConfig } from "../config"

/**
 * Stores the maintenance bypass key in the localStorage, and initializes its timestamp.
 *
 * @param key the bypass key
 */
export const updateBypassKey = (key: string): void => {
  getMaintenanceModeConfig().storageAPI.setStorageItem(KEY_STORAGE_ITEM, key)
  getMaintenanceModeConfig().storageAPI.setStorageItem(TIMESTAMP_STORAGE_ITEM, Date.now().toString())
}

/**
 * Returns the maintenance bypass key, if the last access (touch) is younger than
 * `MaintenanceBypass.KEY_TIMEOUT` minutes.
 * Otherwise the bypass key is removed from storage (cleaned up).
 */
export const touchBypassKey = (): string | null => {
  const key = getMaintenanceModeConfig().storageAPI.getStorageItem(KEY_STORAGE_ITEM)
  const timestampString = getMaintenanceModeConfig().storageAPI.getStorageItem(TIMESTAMP_STORAGE_ITEM)
  const deadline = Number.parseInt(timestampString, 10) + getMaintenanceModeConfig().bypassKeyTimeout * 60 * 1000
  const now = Date.now()

  // If stored maintenance key is younger than `BYPASS_MAINTENANCE_TIMEOUT` minutes,
  // refresh it and return it.
  if (now < deadline) {
    getMaintenanceModeConfig().storageAPI.setStorageItem(TIMESTAMP_STORAGE_ITEM, Date.now().toString())
    return key
  }

  // otherwise, remove key and timestamp
  removeBypassKey()
  return null
}

/**
 * Removes the maintenance bypass key from localStorage.
 */
export const removeBypassKey = (): void => {
  getMaintenanceModeConfig().storageAPI.removeStorageItem(KEY_STORAGE_ITEM)
  getMaintenanceModeConfig().storageAPI.removeStorageItem(TIMESTAMP_STORAGE_ITEM)
}